import { ACTION_TYPES } from '~/core/constants'
import { capitalize } from '~/core/utils/text'

const { SALESFORCE } = ACTION_TYPES

const normalizeRecord = record => ({
  ...record,
  closeDate: record.closeDate ? new Date(record.closeDate).toLocaleDateString() : null,
  displayType: capitalize(record.type)
})

const mergeRecords = (seed, payload) =>
  payload.reduce((acc, record) => {
    const normalizedRecord = normalizeRecord(record)
    const { id } = normalizedRecord

    acc[id] = {
      ...seed[id],
      ...normalizedRecord
    }

    return acc
  }, seed)

const initialState = {
  email: null,
  isLoggedIn: false,
  isSearching: false,
  hasPermissions: true,
  records: {}, // salesforce objects
  mappings: {}, // mappings between session ids and corresponding salesforce tags
  recents: [], // recent salesforce object ids
  search: [], // current search salesforce object ids,
  searchText: ''
}

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case SALESFORCE.FETCHED_ITEM_DETAILS:
      return {
        ...state,
        records: mergeRecords(state.records, [{
          ...action.payload,
          hasDetails: true
        }])
      }
    case SALESFORCE.FETCHED_SESSION_TAGS:
      return {
        ...state,
        hasPermissions: true,
        mappings: {
          ...state.mappings,
          [action.payload.sessionId]: action.payload.tags
        },
        records: mergeRecords(state.records, action.payload.tags)
      }
    case SALESFORCE.FETCHED_SEARCH_RECORDS:
      return {
        ...state,
        isSearching: false,
        records: mergeRecords(state.records, action.payload),
        search: action.payload.map(r => r.id)
      }
    case SALESFORCE.FETCHED_RECENTS:
      return {
        ...state,
        recents: action.payload.map(r => r.id),
        records: mergeRecords(state.records, action.payload)
      }
    case SALESFORCE.FETCHING_SEARCH_RECORDS:
      return {
        ...state,
        isSearching: true
      }
    case SALESFORCE.FETCH_SEARCH_RECORDS_ERROR:
      return {
        ...state,
        isSearching: false
      }
    case SALESFORCE.REMOVE_ITEM:
      return {
        ...state,
        mappings: {
          ...state.mappings,
          [action.payload.sessionId]: state.mappings[action.payload.sessionId].filter(({ id }) => id !== action.payload.recordId)
        }
      }
    case SALESFORCE.SET_IS_LOGGED_IN:
      return {
        ...(action.payload ? state : initialState),
        isLoggedIn: action.payload
      }
    case SALESFORCE.SET_SEARCH_TEXT:
      return {
        ...state,
        searchText: action.payload
      }
    case SALESFORCE.SET_USER_INFO:
      return {
        ...state,
        email: action.payload
      }
    case SALESFORCE.SET_HAS_PERMISSIONS:
      return {
        ...state,
        hasPermissions: action.payload
      }
    default:
      return state
  }
}

export default reducer
